import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import lumnisLogo from "../../assets/images/logo/lumnis.png";
import appleBrand from "../../assets/images/brands/apple.png";
import playStoreBrand from "../../assets/images/brands/playstore.png";

export const Footer = () => {
  return (
    <footer>
      <div className="bg-gray py-5">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col lg="4" className="mb-4">
              <Link to="/">
                <img
                  src={lumnisLogo}
                  alt="logo"
                  width="100%"
                  height="auto"
                  className="mw-200 img-fluid obj-fit-cover obj-position-center mb-3"
                />
              </Link>
              <p>Democratizing Investment Insights</p>
              <div>
                <img
                  src={appleBrand}
                  alt="Apple brand"
                  className="img-fluid obj-fit-cover obj-position-center mw-100 mr-2"
                />
                <img
                  src={playStoreBrand}
                  alt="playstore brand"
                  className="img-fluid obj-fit-cover obj-position-center mw-100"
                />
              </div>
            </Col>
            <Col lg="8" xl="7" className="mb-4">
              <div
                className="d-flex flex-wrap align-items-center"
                style={{ gap: "30px" }}
              >
                <Link to="/" className="text-decoration-none">
                  <p className="font-weight-semibold text-black">
                    Privacy Policy
                  </p>
                </Link>
                <Link to="/" className="text-decoration-none">
                  <p className="font-weight-semibold text-black">
                    Terms of Sevice
                  </p>
                </Link>
                <Link to="/" className="text-decoration-none">
                  <p className="font-weight-semibold text-black">Disclaimer</p>
                </Link>
                <div>
                  <p className="font-weight-semibold text-black">Contact Us</p>
                  <p className="subparagraph mb-2">Abubakarr Jaye</p>
                  <p className="subparagraph mb-2">ajaye@lumnis.org</p>
                  <p className="subparagraph mb-2">+1 (475) 204 9979</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-white">
        <Container>
          <p className="text-center m-0 py-2 subparagraph text-black">
            Copyright &copy; Lumnis 2022. All Rights Reserved.
          </p>
        </Container>
      </div>
    </footer>
  );
};
